// API Configuration
// Use environment variable for production deployments
// Empty string for local development (uses setupProxy.js)

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
